import { Component, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideLink } from '@ng-icons/lucide';

@Component({
  selector: 'gs-adlink-link-cell',
  imports: [NgIcon],
  viewProviders: [provideIcons({ lucideLink })],
  template: `
    @if (link()) {
      <a [href]="link()" target="_blank" rel="noopener" class="link-cell">
        <ng-icon name="lucideLink" aria-hidden="true" />
      </a>
    }
  `,
  styles: [
    `
      .link-cell {
        color: inherit;
        display: inline-flex;
      }
    `,
  ],
})
export class GsAdlinkLinkCellComponent {
  readonly link = input<string | null>(null);
}
